<script setup lang="ts">
import { computed, getCurrentInstance } from 'vue'

interface Props {
    cols?: '2' | '3' | '4' | '5' | '6' | '12'
    lg?: '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '11'
    md?: '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '11'
    sm?: '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '11'
    mobile?: string
}

const props = withDefaults(defineProps<Props>(), {
    cols: '12',
    lg: undefined,
    md: undefined,
    sm: undefined,
    mobile: 'w-full',
})

const ctx = getCurrentInstance()
const padding = ctx?.parent?.props.padding ?? '5'

const classes = computed(() => {
    const sm = props.sm ? ` sm:w-${props.sm}/${props.cols} ` : ''
    const md = props.md ? ` md:w-${props.md}/${props.cols} ` : ''
    const lg = props.lg ? ` lg:w-${props.lg}/${props.cols} ` : ''
    const mobile = props.mobile ? ` ${props.mobile} ` : ''

    return `${mobile}${sm}${md}${lg}px-${padding}`
})
</script>

<template>
    <div :class="classes">
        <slot />
    </div>
</template>
